"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var getThemeSource = function getThemeSource(id, ts, isDarkMode, isRTL) {
  if (ts) {
    for (var i = 0; i < ts.length; i++) {
      if (ts[i]['id'] === id) {
        var source = ts[i]['source'];
        var palette = source != null ? source.palette : {};
        return (0, _styles.createMuiTheme)(_extends(_extends({}, source), {}, {
          palette: _extends(_extends({}, palette), {}, {
            type: isDarkMode ? 'dark' : 'light'
          }),
          direction: isRTL ? 'rtl' : 'ltr'
        }));
      }
    }
  }

  return (0, _styles.createMuiTheme)({
    palette: {
      type: isDarkMode ? 'dark' : 'light'
    },
    direction: isRTL ? 'rtl' : 'ltr'
  });
};

var _default = getThemeSource;
exports.default = _default;
module.exports = exports.default;